import { render, staticRenderFns } from "./UpdaterAdmin.vue?vue&type=template&id=127c0ce0"
import script from "./UpdaterAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdaterAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpdaterAdmin.vue?vue&type=style&index=0&id=127c0ce0&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports